import styled from 'styled-components'
import InputMask from 'react-input-mask';

export const Form = styled.form`
    margin-top: 10px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
`

export const LeftColumn = styled.div`
    border-right: 1px solid #ECEDF2;
    padding-right: 30px;
    display: flex;
    flex-direction: column;
    flex: 1;
`

export const RightColumn = styled.div`
    padding-left: 30px;
    display: flex;
    flex-direction: column;
    flex: 1;
`

export const Input = styled(InputMask)`
    font-size: 12px;
    border: 0;
    background-color: transparent;
    width: 100%;
    padding: 5px 0;
    height: 20px;
    &::placeholder {
        color: #AEAEBA;
    }
`

export const CheckboxInput = styled.label`
  display: flex;
  align-items: center;
  color: ${props => props.isSimulation ? '#2E2E37' : '#AEAEBA'};
  line-height: 18px;
  height: auto;
  cursor: pointer;
  margin-bottom: 10px;
  font-size: 12px;
`

export const CheckBox = styled.input`
  transition: all 0.2s ease-out;
  appearance: none;
  cursor: pointer;
  border: 2px solid #DFE0E7;
  width: 20px;
  height: 18px;
  padding: 0;
  margin-right: 10px;
  border-radius: 4px;

  &:checked {
    transition: all 0.2s ease-in;
    border-color: transparent;
    width: 20px;
    height: 18px;
    background-color: #f3123c;
    background-image: url('/assets/img/icon/check-white.svg');
    background-size: 80%;
    background-position: center;
    background-repeat: no-repeat;
  }

`

export const Text = styled.p`
    color: #2E2D37;
    width: 95%;
`

export const ChangeInfo = styled.button`
    background-color: transparent;
    border: 0;
    color: #2E2D37;
    font-size: 11px;
    margin-top: 5px;
    text-align: left;
    cursor: pointer;

    opacity: ${props => props.hasCookies ? '1' : '0'};
    transition: opacity 0.5s;

    &:hover {
        text-decoration: underline
    }
`

export const InputContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    border: ${props => props.hasCookies ? '0' : '2px solid #ecedf2'};
    border-radius: 8px;
    background-color: #fff;
    padding: ${props => props.hasCookies ? '8px 18px' : '12px 18px'};

    transition: all 0.5s ease-out;

    &:focus-within {
        transition: all 0.2s ease-in;
        border-color: #2E2D37;
    }

    & + div {
        margin-top: 5px;
    }

    div {
        width: 0;
        margin-right: ${props => props.hasCookies && '20px'}
    }
`
